import React, { createContext, useContext, useRef } from "react";

const GlobalCounterContext = createContext();

export const GlobalCounterProvider = ({ children }) => {
  const counter = useRef(1);

  const getNextGlobalNumber = () => counter.current++;
  const resetGlobalCounter = () => (counter.current = 1);

  return (
    <GlobalCounterContext.Provider
      value={{ getNextGlobalNumber, resetGlobalCounter }}
    >
      {children}
    </GlobalCounterContext.Provider>
  );
};

export const useGlobalQuestionCounter = () => useContext(GlobalCounterContext);
